import {Button} from "antd";
import React from "react";

export default function GrayButton({children, style = {}, ...props}) {

    return (
        <Button
            size={'small'}
            style={{
                width: 350,
                height: 32,
                fontFamily: 'Segoe ui',
                fontSize: '9pt',
                backgroundColor: '#f0f2f5',
                textAlign: 'start',
                ...style
            }}
            {...props}
        >
            {children}
        </Button>
    )
}